export default "__VITE_ASSET__D7qS95uE__"